import axios from 'axios'
import { getSavedState, saveState } from '../store-utils'

export const state = {
  cachedTypes: getSavedState('device.types'),
  selectedType: null,
}

export const getters = {
  // Whether the user is currently logged in.
  cachedTypes(state) {
    return state.cachedTypes
  },

  selectedType(state) {
    return state.selectedType
  },
}

export const mutations = {
  SET_CACHE(state, types) {
    state.cachedTypes = types
    saveState('device.types', types)
  },

  SET_SELECTED(state, type) {
    state.selectedType = type
  },
}

export const actions = {
  selectType({ commit, state, rootState }, { type }) {
    commit('SET_SELECTED', type)
  },

  fetchTypes({ commit, state, rootState }, { clearCache }) {
    // 1. Check if we've already fetched and cachedTypes the user.
    const matchedDevices = state.cachedTypes
    if (!clearCache && matchedDevices) {
      return Promise.resolve(matchedDevices)
    }

    // 2. Fetch the devices from the API and cache it in case
    // we need it again in the future.
    return axios
      .get('/api/services/app/DeviceType/GetAll')
      .then((response) => {
        const devices = response.data.items
        commit('SET_CACHE', devices)
        return devices
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },

  updateType({ commit, dispatch, state, rootState }, { type }) {
    return axios
      .put('/api/services/app/DeviceType/Update', type)
      .then((response) => {
        dispatch('fetchTypes', { clearCache: true }).then((resp) => {
          commit('SET_SELECTED', null)
        })
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },
}
